/**
 * Mini-program add-maintenance scan: vehicle number vs IOT/part.
 * Scanning a new IOT must not clear an already selected manufacturer.
 */
function getMaintainScanApply (scanTarget) {
  if (scanTarget == null) {
    return { field: 'ebikeCode', refreshTenant: true }
  }
  return { field: 'newPartCode', refreshTenant: false }
}

function applyMaintainScan (form, scanTarget, decodedText) {
  const apply = getMaintainScanApply(scanTarget)
  if (apply.field === 'ebikeCode') {
    form.ebikeCode = decodedText
  } else {
    scanTarget.newPartCode = decodedText
  }
  if (apply.refreshTenant) {
    form.tenantId = ''
  }
  return apply
}

module.exports = {
  getMaintainScanApply,
  applyMaintainScan
}
